// extracted by mini-css-extract-plugin
module.exports = {"clientRow":"styles_clientRow__2ZIhT","clientRow__infos":"styles_clientRow__infos__2D8-M","clientRow__title":"styles_clientRow__title__1v2lZ"};